// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonButton_wrapper__giUnE","disableButton":"CommonButton_disableButton__hg0+6"};